import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
      <div className="container nav-content">
        <Link to="/" className="brand-logo">
          <img
            src="/image/logo.webp"
            alt="KidsGuru Logo"
            className="header-logo-img"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <div className="logo-icon-box" style={{ display: 'none' }}>K</div>
          <span className="brand-title">
            <span className="brand-kids">Kids</span>
            <span className="brand-guru">Guru</span>
          </span>
        </Link>

        <ul className="nav-links">
          <li><a href="#features" className="nav-link">Features</a></li>
          <li><a href="#screens" className="nav-link">Screenshots</a></li>
          <li><a href="#why-us" className="nav-link">Why KidsGuru</a></li>
          <li><a href="#languages" className="nav-link">Languages</a></li>
        </ul>

        <a
          href="/download"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-header-cta pulse-anim"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Download App
        </a>
      </div>
    </header>
  );
};

export default Header;
